"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logLevel_1 = require("./logLevel");
var Config = /** @class */ (function () {
    function Config(config) {
        this.config = config;
    }
    Config.getInstance = function (config) {
        if (!Config.instance && config) {
            Config.instance = new Config(config);
        }
        return Config.instance;
    };
    Config.prototype.getSettings = function () {
        return this.config;
    };
    Config.prototype.getHashKey = function () {
        return this.config.HashKey;
    };
    Config.prototype.getLogger = function () {
        return (typeof this.config.Logger !== "undefined") ? this.config.Logger : { level: logLevel_1.default.DISABLED };
    };
    Config.prototype.getIdentityConsent = function () {
        return (typeof this.config.HasIdentityConsent !== "undefined") ? this.config.HasIdentityConsent : true;
    };
    Config.prototype.getDomain = function () {
        return this.config.Domain;
    };
    Config.prototype.getAnalyticsURL = function () {
        return this.config.AnalyticsURL;
    };
    Config.prototype.getEnvironment = function () {
        return this.config.Environment;
    };
    Config.prototype.getApiURL = function () {
        return this.config.ApiURL;
    };
    Config.prototype.getAppToken = function () {
        return this.config.AppToken;
    };
    Config.prototype.setApiURL = function (url) {
        this.config.ApiURL = url;
    };
    return Config;
}());
exports.default = Config;
//# sourceMappingURL=config.js.map